import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

export class pay4PopupTab extends HTMLElement {
  connectedCallback() {
  }

  disconnectedCallback() {
  }

  updateTab = () => {
    // 1) get the total price (variant*quantity) + warranty + product upsell
    let currentPrice = 0;
    let productDetails = document.querySelector('.product-details');
      if (productDetails instanceof HTMLElement && productDetails.dataset.totalPrice ) {
        currentPrice = Number(productDetails.dataset.totalPrice);
      }

    // 2) format the price
    let priceIn4 = currentPrice / 4.0;
    let formattedPrice = `$${(currentPrice / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    let formattedPriceIn4 = `$${(priceIn4 / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    
    // 3) replace the placeholders - show the new price in the tab
    let fullMoneyExist = this.querySelector(".full_money_span");
    if (fullMoneyExist) { fullMoneyExist.innerHTML = formattedPrice; }
    let money4Exist = this.querySelector(".money4_span");
    if (money4Exist) { money4Exist.innerHTML = formattedPriceIn4; } 
    this.innerHTML = this.innerHTML.replace(/_full_money_/g, `<span class="full_money_span">${formattedPrice}</span>` )
                    .replace(/_money4_/g, `<span class="money4_span">${formattedPriceIn4}</span>` ); 
  };
}

if (!customElements.get('pay4-popup-tab')) {
  customElements.define('pay4-popup-tab', pay4PopupTab);
}
